import { filtersIds } from 'app/features/teams/key-logger/KeysListFilters/filters.config'

export const isKeySearchFilterApplied = (filter) => filter !== ''

export const KeySearchAppliedRenderer = ({ filterValues }) => filterValues
